<template>
  <div class="project-performance">
    <div class="header row">
      <div class="scores-plane column small-8 medium-8 large-8">
        <span class="title">{{ $t('company.performance.projectPerformance') }}</span>
        <div class="info-span">
          <span
            class="total"
            @click="goToRatingHistory('')"
          >{{ `${totalProjects} projects` }}</span>/
          <span
            class="total"
            @click="goToRatingHistory('')"
          >{{ evaluationsCounts }} {{ $t('company.performance.evaluations') }}</span>/
          <span
            class="total"
            @click="goToRatingHistory('comments')"
          >{{ countsWithComments }} {{ $t('company.performance.withComments') }}</span>
        </div>
        <div class="indicator">
          <span class="average-span">{{ $t('company.performance.itemAverage') }}</span><span class="most-span">{{ $t('company.performance.mostSelect') }}</span>
        </div>
      </div>
      <div class="average-score column small-4 medium-4 large-4">
        <div class="item-title">{{ $t('company.performance.averageScore') }}</div>
        <div><span
          class="scores"
          @click="goToRatingHistory('average')"
        >{{ totalAverage + '/100' }}</span></div>
      </div>
    </div>
    <div class="contant">
      <div class="emoji">
        <div class="placehold" />
        <div class="imgs">
          <img
            v-for="(item, index) in srcImgs"
            :title="moodCounts[svgMapToTitle[index]]"
            :src="`/${item}-face.svg`"
            :key="item"
            @click="goToRatingHistory(item)"
          >
        </div>
      </div>
      <div class="vernier-contant">
        <div
          v-for="item in titles"
          :key="item.name.join('')"
          class="vernier-wrap"
        >
          <div class="title">
            <template
              v-for="(name, index) in item.name"
            >
              <br
                v-if="index !== 0"
                :key="index"
              >
              {{ name }}
            </template>
          </div>
          <div class="vernier">
            <vernier
              :percent="item.percent"
              :title="calcVernierPercent(item.averageScore)"
              :secPercent="item.mostSelected.percent"
              :secTitle="`${item.mostSelected.value}`"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vernier from './Vernier'
import lodash from 'lodash'
import moment from 'moment'
import router from '@/router'
import { scoresMap } from './Contains'

export default {
  name: 'ProjectPerformance',
  components: {
    Vernier,
  },
  props: {
    projects: {
      type: Array,
      default: () => [],
    },
    startDay: {
      type: [Date, String],
      default: '',
    },
    endDay: {
      type: [Date, String],
      default: '',
    },
    companyId: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    site: {
      type: Array,
      default: () => [],
    },
    trade: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      srcImgs: ['sad', 'expressionless', 'smile', 'laugh'],
      titles: [
        {
          name: [this.$t('company.performance.designAndPlaning'), this.$t('company.performance.documentation')],
          percent: -1,
          key: 'designPlanningDocumentation',
          mostSelected: {},
        },
        {
          name: [this.$t('company.performance.siteManagement'), this.$t('company.performance.cooperation')],
          percent: -1,
          key: 'siteManagementCooperation',
          mostSelected: {},
        },
        {
          name: [this.$t('company.performance.workQuality')],
          percent: -1,
          key: 'workQuality',
          mostSelected: {},
        },
        {
          name: [this.$t('company.performance.timelyService'), this.$t('company.performance.followUp')],
          percent: -1,
          key: 'timelyServiceFollowUp',
          mostSelected: {},
        },
        {
          name: [this.$t('company.performance.safety'), this.$t('company.performance.environmental')],
          percent: -1,
          key: 'safetyTidinessCleanliness',
          mostSelected: {},
        },
      ],
      moodCounts: {
        'Sadness': 0,
        'Expressionless': 0,
        'Smile': 0,
        'Laugh': 0,
      },
      totalAverage: 0,
      svgMapToTitle: [
        'Sadness',
        'Expressionless',
        'Smile',
        'Laugh',
      ],
      countsWithComments: 0,
      evaluationsCounts: 0,
    }
  },
  computed: {
    totalProjects () {
      return this.projects.length
    },
    startDate () {
      return moment(this.startDay).format('DD MMM YYYY')
    },
    endDate () {
      return moment(this.endDay).format('DD MMM YYYY')
    },
  },
  watch: {
    projects (val) {
      this.calcScores(val)
    },
  },
  methods: {
    calcScores (projects = []) {
      let tmp = 0
      this.resetScores()
      if (!projects.length) {
        return
      }

      this.titles.map(item => {
        item.averageScore = this.calcScoresByName(projects, item.key) - 0
        item.percent = item.averageScore !== -1 ? this.calcVernierPercent(item.averageScore) : -1
        item.mostSelected = this.getMostSelectedMood(projects, item.key)
        tmp += item.averageScore === -1 ? 0 : item.averageScore
      })
      this.totalAverage = (tmp / 5 / 4 * 100).toFixed(1)
    },
    calcVernierPercent (val) {
      return ((val - 1) / 3 * 100).toFixed(2)
    },
    calcScoresByName (projects, name) {
      let totalScores = 0
      let totalCounts = 0
      this.evaluationsCounts = 0
      this.countsWithComments = 0
      projects.map(item => {
        const {total, count, evaluationsCounts, countsWithComments} = this.getValue(lodash.get(item, 'rates'), name)
        totalScores += total
        totalCounts += count
        this.evaluationsCounts += evaluationsCounts
        this.countsWithComments += countsWithComments
      })

      const average = totalCounts ? totalScores / totalCounts : -1
      return average
    },
    getValue (rates, name) {
      let evaluationsCounts = 0
      let countsWithComments = 0
      const countRates = rates.filter(rate => {
        return rate.type !== 'RANDOM'
      })
      const total = lodash.sum(countRates.map(item => {
        item.remark && countsWithComments++
        evaluationsCounts++
        return scoresMap[lodash.get(item, name)] || 0
      },
      ))

      return {total, count: countRates.length, evaluationsCounts, countsWithComments}
    },
    getMostSelectedMood (projects, key) {
      const moodSelected = {
        'Sadness': 0,
        'Expressionless': 0,
        'Smile': 0,
        'Laugh': 0,
      }

      projects.map(project => {
        const rates = lodash.get(project, 'rates')
        rates.map(rate => {
          moodSelected[rate[key]]++
          this.moodCounts[rate[key]]++
        })
      })
      const mostSelectedMood = {
        name: '',
        value: 0,
        percent: 0,
      }
      for (let key in moodSelected) {
        if (mostSelectedMood.value <= moodSelected[key]) {
          mostSelectedMood.name = key
          mostSelectedMood.value = moodSelected[key]
          mostSelectedMood.percent = mostSelectedMood.value ? this.calcVernierPercent(scoresMap[key]) : -1
        }
      }
      return mostSelectedMood
    },
    resetScores () {
      this.titles.map(item => {
        item.percent = -1
        item.mostSelected = {}
      })
      this.evaluationsCounts = 0
      this.countsWithComments = 0
      this.totalAverage = 0
      this.moodCounts = {
        'Sadness': 0,
        'Expressionless': 0,
        'Smile': 0,
        'Laugh': 0,
      }
    },
    goToRatingHistory (str) {
      router.push({
        name: 'performanceRatingHistory',
        params: {
          filter: str,
          startDay: this.startDay,
          endDay: this.endDay,
          site: this.site,
          companyId: this.companyId,
          description: this.description,
          trade: this.trade,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.project-performance {
  margin-top: 20px;
  padding: 20px;
  background: #f8f8f8;
  color: #0C3A58;

  .header {
    .title {
      width: 311px;
      height: 22px;
      font-family: Verdana;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      color: #0c3a58;
    }

    .average-score {
      text-align: right;
      .scores{
        display: inline-block;
        height: 100%;
        font-size: 24px;
        font-weight: bold;
        cursor: pointer;
      }
      .item-title {
        font-size: 12px;
        font-weight: bold;
        color: #4B6888;
      }
    }
  }
  .scores-plane {
    font-size: 18px;
    font-weight: bold;

    .info-span {
      display: inline-block;
      font-size: 12px;
      .total {
        cursor: pointer;
      }
    }

    .title {
      cursor: default;
    }
  }
  .indicator {
    font-size: 12px;
    padding-bottom: 5px;
    font-weight: normal;
    .most-span, .average-span {
      display: inline-block;
      &:before {
        content: '';
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        margin-right: 5px;
      }
    }
    .most-span {
      color: #7194ac;
      &:before {
        background: #7194ac;
      }
    }
    .average-span {
      color: #0c3a58;
      margin-right: 20px;
      &:before {
        background: #0c3a58;
      }
    }
  }
  .contant {
    height: 337px;
    display: flex;
    background: #ffffff;
    flex-direction: column;
    padding: 20px;
    padding-bottom: 0px;
    .emoji {
      height: 20px;
      margin-bottom: 5px;
      display: flex;
      .placehold {
        width: 120px;
      }
     .imgs {
        flex: 1;
        img {
          height: 20px;
          width: 20px;
          margin-left: calc( 33% - 20px );
          float: left;
          cursor: pointer;
        }
        img:first-child {
          margin-left: -10px;
        }
        img:nth-child(3) {
          margin-left: calc( 33% - 25px );
        }
        img:last-child {
          margin-left:0;
          float: right;
        }
     }
    }
    .vernier-contant{
      flex: 1;
      clear: both;
      display: flex;
      flex-direction: column;
      font-family: Verdana;
      font-size: 12px;
      .vernier-wrap {
        flex: 1;
        display: flex;
        .title {
          flex-basis: 120px;
          flex-shrink: 0;
          flex-grow: 0;
          align-self: center;
          padding-top: 5px;
          padding-right: 10px;
          width: 120px;
        }
        .vernier {
          margin-right: 10px;
          width: 100%;
          display: inline-block;
          align-self: center;
        }
      }
    }
  }
}
</style>
